import { lazy } from 'react';

const popups = {
  auth: lazy(() => import('./auth')),
  wallet: lazy(() => import('./wallet')),
  contract: lazy(() => import('./contract')),
  betHistory: lazy(() => import('./betHistory')),
  blockchainSync: lazy(() => import('./blockchainSync')),
  logoutAlert: lazy(() => import('./logoutAlert')),
  channelCreation: lazy(() => import('./channelCreation')),
  requestChannelCreate: lazy(() => import('./requestChannelCreate')),
};

export default popups;
